import React, { useState, useEffect } from "react";
import api from "../../../config/axiosConfig";
import { Container, Row, Col } from "react-bootstrap";
import { FaIndianRupeeSign } from "react-icons/fa6";
import Footer from '../Footer/Footer';
import Header from '../Header';
import banner from "../../../assets/sectbanner.webp";
import '../../../index.css'

// import { usePDF } from "../../../PDFContext";

function Food() {
  const [foodByCategory, setFoodByCategory] = useState({}); // Initialize with an empty object
  const [visibleDescriptions, setVisibleDescriptions] = useState({}); // Track visible descriptions
  const [media, setMedia] = useState({}); // Media mapping by item ID

  // const { foodWithPdfRef } = usePDF();

  const handleDescriptionToggle = (itemId) => {
    setVisibleDescriptions((prev) => ({
      ...prev,
      [itemId]: !prev[itemId], // Toggle the visibility of the clicked item
    }));
  };

  useEffect(() => {
    const fetchFood = async () => {
      try {
        const fetchedItems = await api.get("/items/joined");
        const fetchMedia = await api.get("/media");

        // Create a media map using itemId as key
        const mediaMap = fetchMedia.data.reduce((acc, media) => {
          acc[media.itemId] = media.path; // Media mapped by itemId
          return acc;
        }, {});
        setMedia(mediaMap);

        // Filter for food items
        const foodItems = fetchedItems.data.filter(
          (item) => item.itemtype_name === "Food & Beverage"
        );

        // Group food items by category
        const groupedByCategory = foodItems.reduce((acc, item) => {
          const category = item.category_name || "Uncategorized"; // Use "Uncategorized" if category is missing
          if (!acc[category]) {
            acc[category] = [];
          }
          acc[category].push(item);
          return acc;
        }, {});

        setFoodByCategory(groupedByCategory);
      } catch (error) {
        console.error("Error fetching category:", error);
      }
    };

    fetchFood();
  }, []);

  return (
    <div
    style={{
      position: "absolute",
      left: "-9999px", // Move it off-screen
      width: "0px",
      height: "0px",
      overflow: "hidden",
    }}
    >
    <Header/>
     
      <div className="food-section">
      <div className="text-center"><h2 className="bannar-text pb-5">Menu</h2></div>
      <div className="foodparalax px-md-5 px-3 pb-5">
      <div className="container-fluid px-md-5 px-3 ">
          <Row className="g-4">
            {Object.keys(foodByCategory).length > 0 ? (
              Object.entries(foodByCategory).map(([category, items], index) => {
                // Use the first item's itemId as the representative item for the category
                const representativeItemId = items[0]?.item_id;
                
                return (
                  <Col md={4} key={index}>
                    <div className="h-100">
                      <div
                        className="p-md-5 p-3 food-div"
                      >
                        <h4 className="text-white pb-3 foodheading">{category}</h4>
                        <ul className="ps-0">
                          {items.map((item, idx) => (
                            <li
                              className="d-flex gap-4 align-items-start justify-content-between py-3"
                              key={idx}
                              style={{ borderBottom: "1px solid #ffffff40" }}
                            >
                              <div className="d-flex flex-column gap-2 food-box">
                                <div className="d-flex align-items-center gap-2">
                                  {item.attribute === "Non Veg" && (
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: "11px",
                                        height: "11px",
                                        borderRadius: "50%",
                                        backgroundColor: "#e45353",
                                      }}
                                    ></span>
                                  )}
                                  <h6
                                    className="food-name"
                                    style={{ cursor: "pointer", color: "#e6be80" }}
                                    onClick={() => handleDescriptionToggle(item.item_id)}
                                  >
                                    {item.item_name}
                                  </h6>
                                </div>
                                {visibleDescriptions[item.item_id] && (
                                  <small className="text-sm text-white">
                                    {item.shortdesc}
                                  </small>
                                )}
                              </div>
                              <div className="d-flex align-items-center">
                                {item.perpersonrateINR && (
                                  <>
                                    <FaIndianRupeeSign />
                                    {item.perpersonrateINR}
                                  </>
                                )}
                                {!item.perpersonrateINR && "-"}
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </Col>
                );
              })
            ) : (
              <p>Loading...</p>
            )}
          </Row>
        </div>
</div>
       
      </div>
      <Footer />
    </div>
  );
}

export default Food;
